import { Injectable } from "@nestjs/common";
import { InjectRepository } from "@nestjs/typeorm";
import { SamplecoLineFilterReq } from "@project-management-system/shared-models";
import { Repository } from "typeorm";
import { SamplecoLineEntity } from "../entities/sample-coLine.entity";



@Injectable()
export class SampleCoLineRepo extends Repository<SamplecoLineEntity> {

    constructor(@InjectRepository(SamplecoLineEntity) private samplePoOrdersRepo: Repository<SamplecoLineEntity>
    ) {
        super(samplePoOrdersRepo.target, samplePoOrdersRepo.manager, samplePoOrdersRepo.queryRunner);
    }

    async getDataforCOLineCreation(): Promise<any> {
        const query = this.createQueryBuilder('co')
            .select(`co.id, co.buyer_po, co.item_no, co.buyer_code`)
            .where(` status != 'SUCCESS' AND status != 'INPROGRESS' AND is_active = true`)
            .orderBy(` created_at`, 'ASC')
        return await query.getRawOne();
    }

    async getAllcolineData(req?: SamplecoLineFilterReq): Promise<any[]> {
        let query = this.createQueryBuilder('co')
            .select(`*`)
        if (req?.buyerPo !== undefined) {
            query = query.andWhere('co.buyer_po =:buyerPo', { buyerPo: req?.buyerPo })
        }
        if (req?.itemNo !== undefined) {
            query = query.andWhere('co.item_no =:itemNo', { itemNo: req?.itemNo })
        }
        if (req?.buyerCode !== undefined) {
            query = query.andWhere('co.buyer_code =:buyerCode', { buyerCode: req.buyerCode })
        }

        if (req.buyerStyle !== undefined) {
            query = query.andWhere('co.buyer_style = :buyerStyle', { buyerStyle: req.buyerStyle });
        }
        // console.log(req, "reeepp")
        // const query = this.createQueryBuilder('co')
        //     .select(`*`)
        //     .where(`co.is_active = true'`)
        // return await query.getRawOne();
        // if (req?.buyerPo !== undefined) {
        //     query.andWhere(`co.buyer_po ='${req?.buyerPo}'`)
        // }
        // if (req?.itemNo !== undefined) {
        //     query.andWhere(`co.item_no ='${req?.itemNo}'`)
        // }
        // if (req?.buyerCode !== undefined) {
        //     query.andWhere(`co.buyer_code ='${req?.buyerCode}'`)
        // }
        // if (req?.buyerStyle !== undefined) {
        //     query.andWhere(`co.buyer_style ='${req?.buyerStyle}'`)
        // }
        // // if (req.deliveryDateStart !== undefined) {
        // //     query.andWhere(`STR_TO_DATE(co.delivery_date, '%Y-%m-%d') BETWEEN '${req.deliveryDateStart}' AND '${req.deliveryDateEnd}'`)
        // // }
        query.orderBy('co.created_at', 'DESC');
        return await query.getRawMany()
    }

}
